var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "goal-summary",
      class: _vm.mobile ? "pt-2 ps-1 pb-1" : "pt-4 ps-6 pb-3",
    },
    [
      _c("div", { staticClass: "ms-6" }, [
        _c("div", { class: _vm.mobile ? "text-h5" : "text-h4" }, [
          _vm._v(_vm._s(_vm.userGoal.goal.name)),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "d-flex flex-row align-self-center" }, [
        _c(
          "div",
          { staticClass: "d-flex align-self-center" },
          [
            _c(
              "v-progress-circular",
              {
                class: _vm.mobile ? "m-2" : "m-3",
                attrs: {
                  rotate: 270,
                  size: _vm.mobile ? 100 : 140,
                  width: _vm.mobile ? 10 : 15,
                  value: _vm.userGoal.progressRate,
                  color: "white",
                },
              },
              [
                _c("div", { staticClass: "align-center" }, [
                  _c(
                    "div",
                    {
                      staticClass: "text-caption",
                      staticStyle: { "text-align": "center" },
                    },
                    [_vm._v("進捗率")]
                  ),
                  _vm._v(" "),
                  _c("span", { class: _vm.mobile ? "text-h6" : "text-h3" }, [
                    _vm._v(_vm._s(_vm.userGoal.progressRate) + " "),
                  ]),
                  _vm._v(" "),
                  _c(
                    "span",
                    { style: { marginLeft: _vm.mobile ? "-5px" : "-10px" } },
                    [_vm._v("%")]
                  ),
                ]),
              ]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "d-flex align-self-center flex-column ms-2" },
          [
            _c("div", [
              _c("div", { class: _vm.mobile ? "text-caption" : "" }, [
                _vm._v("目標期間"),
              ]),
              _vm._v(" "),
              _c("div", { class: _vm.mobile ? "text-caption" : "text-h6" }, [
                _vm._v(
                  "\n          " +
                    _vm._s(
                      _vm.dateFormat(_vm.userGoal.startDate, "YYYY/MM/DD")
                    ) +
                    "～" +
                    _vm._s(_vm.dateFormat(_vm.userGoal.endDate, "YYYY/MM/DD")) +
                    "\n        "
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "d-flex" }, [
              _c("div", { class: _vm.mobile ? "mt-1" : "mt-4" }, [
                _c("div", { class: _vm.mobile ? "text-caption" : "" }, [
                  _vm._v("残り日数"),
                ]),
                _vm._v(" "),
                _c("span", { class: _vm.mobile ? "text-h5" : "text-h3" }, [
                  _vm._v(_vm._s(_vm.userGoal.daysRemaining)),
                ]),
                _c("span", { class: _vm.mobile ? "text-caption" : "" }, [
                  _vm._v("日"),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "ms-6", class: _vm.mobile ? "mt-1" : "mt-4" },
                [
                  _c("div", { class: _vm.mobile ? "text-caption" : "" }, [
                    _vm._v("ステータス"),
                  ]),
                  _vm._v(" "),
                  _vm.userGoal.isOutSchedule
                    ? _c(
                        "v-chip",
                        {
                          staticClass: "m-2",
                          attrs: {
                            color: "red",
                            "text-color": "white",
                            small: _vm.mobile ? true : false,
                          },
                        },
                        [_vm._v("\n            遅れてます\n          ")]
                      )
                    : _vm.userGoal.isLate
                    ? _c(
                        "v-chip",
                        {
                          staticClass: "m-2",
                          attrs: {
                            color: "green",
                            "text-color": "white",
                            small: _vm.mobile ? true : false,
                          },
                        },
                        [_vm._v("\n            やや遅れています\n          ")]
                      )
                    : _vm.userGoal.isOnSchedule
                    ? _c(
                        "v-chip",
                        {
                          staticClass: "m-2",
                          attrs: {
                            color: "primary",
                            small: _vm.mobile ? true : false,
                          },
                        },
                        [_vm._v("\n            順調\n          ")]
                      )
                    : _vm._e(),
                ],
                1
              ),
            ]),
          ]
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }